export default __webpack_public_path__ + "static/media/recenter-icon.782b5b58.svg";